import React from "react";
import { Reducer, TenantStateType, TenantDispatch } from "./reducer";

export const TenantStateContext = React.createContext<TenantStateType>({
  data: [],
});
export const TenantDispatchContext = React.createContext<
  TenantDispatch | undefined
>(undefined);

interface TenantProviderProps {}

type TenantProviderPropsType = React.PropsWithChildren<TenantProviderProps>;

export const TenantProvider: React.FC<TenantProviderPropsType> = ({
  children,
}: TenantProviderPropsType) => {
  const [state, dispatch] = React.useReducer(Reducer, {
    data: [],
  });
  return (
    <TenantDispatchContext.Provider value={dispatch}>
      <TenantStateContext.Provider value={state}>
        {children}
      </TenantStateContext.Provider>
    </TenantDispatchContext.Provider>
  );
};

export const useTenantState = () => {
  const state = React.useContext(TenantStateContext);
  return state;
};

export const useTenantDispatch = () => {
  const dispatch = React.useContext(TenantDispatchContext);
  return dispatch;
};
